

















































































































































































































































/** @format */
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import {
  nonnegativeInteger,
  nonnegativeInteger0,
  positiveInteger,
  postivePrice,
  chineseCharacter,
  postiveZero
} from '@root/utils/validators';
import { addOrEditPackage, getMerchantByOrgIdAndType, editCheck } from '@/api/package-management/index';
import Utils from '@root/utils/common';
import { couponTypeMap } from '@/types/package-management/dictionaries';
import ParkingLotSearch from '@/components/parking-lot-search/index.vue';
import OrganizationSearch from '@/components/organization-search/index.vue';
import ModalConfig from '@/components/modal-config/index.vue';
import moment from 'moment';
import * as _ from 'lodash';
export interface IForm {
  orgId: string;
  merchantIds: any[]; //商家Id
  type: string; // 适用商家类型
  packageName: string; // 套餐名称
  quota: string; // 优惠数额
  limits: string; //购买限制数量
  packageExpirationDate: any; //套餐有效期 yyyy-MM-dd
  packageType: string; //优惠券类型：01 时长优惠 02金额优惠
  price: string; //套餐原价
  discountPrice: string; //优惠价
  moveTime: any; //套餐停售日期
  describes: string; //套餐简介
}
const chineseValidation = (tip: string) => {
  return function(rule: any, value: any, callback: Function) {
    if (!value) callback();
    else {
      if (value.length > 20) {
        callback(new Error(tip));
      } else {
        callback();
      }
    }
  };
};
@Component({
  name: 'AddEditModal',
  components: { ParkingLotSearch, ModalConfig, OrganizationSearch }
})
export default class AddEditModal extends Vue {
  // 是否编辑状态
  @Prop({ type: Boolean, default: false })
  isEdit!: boolean;

  // 是否显示机构
  @Prop({ type: Boolean, default: false })
  showFlag!: boolean;
  // 是否展示弹窗
  @Prop({ type: Boolean, default: false })
  visible!: boolean;
  // 编辑状态回填数据
  @Prop()
  data!: any;
  // 是否详情
  @Prop({ type: Boolean, default: false })
  isDetail?: boolean;
  //是否是复制
  @Prop({ type: Boolean, default: false })
  isCopy?: boolean;
  //是否只能修改部分
  @Prop({ type: String, default: '01' })
  updateStatus?: string;
  form: any = null;

  options = _.filter(Utils.toLabelVal(couponTypeMap), function(o) {
    return o.value != '02';
  });
  businessTypeOptions = Utils.toLabelVal(this.$store.state.dictionaries.allDictionaries.cp_merchant_merc_type);
  labelCol = { span: 6 };
  wrapperCol = { span: 15 };
  packageId: string | null = '';
  confirmLoading: boolean = false;
  couponOptions: any[] = [];
  merchantName = '';
  validatorsDay = nonnegativeInteger; //购买限制校验
  validatorsValue = nonnegativeInteger0; //优惠数额校验
  validatorPrice = postivePrice;
  private moment = moment;
  validatorsName = chineseValidation;
  validatorZero = postiveZero;
  //所选商家list
  selectedList: any[] = [];
  //回填可购买此套餐的商家
  oldChangeMerchantIds: any[] = [];
  refresh: boolean = false;
  disabledStartDate(startValue: any) {
    const endValue = this.form.getFieldValue('packageExpirationDate');
    if (!startValue || !endValue) {
      return startValue && startValue < moment(new Date()).subtract(1, 'days');
    }
    if (endValue && endValue._f) {
      return startValue < moment().subtract(1, 'days') || startValue > moment(endValue);
    }
    return startValue < moment().subtract(1, 'days') || startValue > moment(endValue).add(1, 'days');
  }
  disabledEndDate(endValue: any) {
    const startValue = this.form.getFieldValue('moveTime');
    if (!endValue || !startValue) {
      return endValue && endValue < moment(new Date()).subtract(1, 'days');
    }
    if (startValue && startValue._f) {
      return endValue && endValue < moment(startValue);
    }
    return endValue && endValue < moment(startValue).subtract(1, 'days');
  }
  //form初始化
  init() {
    this.couponOptions = [];
    if ((this.isEdit && this.data) || (this.isCopy && this.data)) {
      const {
        pkPackageId,
        type,
        packageName,
        quota,
        packageExpirationDate,
        limits,
        orgDepId,
        packageType,
        moveTime,
        price,
        discountPrice,
        describes,
        merchants
      } = this.data;
      this.form = this.$form.createForm(this, {
        mapPropsToFields: () => {
          this.getMerchantList(orgDepId);
          this.packageId = pkPackageId;
          const merchantIds = [];
          if (merchants.length > 0) {
            this.selectedList = merchants;
            for (let i = 0; i < merchants.length; i++) {
              merchantIds.push(merchants[i].pkMerchantId);
            }
            this.oldChangeMerchantIds = JSON.parse(JSON.stringify(merchants));
          }
          if (this.isCopy) {
            this.packageId = null;
            this.oldChangeMerchantIds = [];
          }
          return {
            packageType: this.$form.createFormField({
              value: packageType
            }),
            orgId: this.$form.createFormField({
              value: orgDepId
            }),
            type: this.$form.createFormField({
              value: type
            }),
            packageName: this.$form.createFormField({
              value: this.isCopy ? `${packageName}-复制` : packageName
            }),
            quota: this.$form.createFormField({
              value: quota
            }),
            limits: this.$form.createFormField({
              value: limits
            }),
            price: this.$form.createFormField({
              value: price
            }),
            discountPrice: this.$form.createFormField({
              value: discountPrice
            }),
            describes: this.$form.createFormField({
              value: describes
            }),
            merchantIds: this.$form.createFormField({
              value: merchantIds
            }),
            packageExpirationDate: this.$form.createFormField({
              value: packageExpirationDate ? this.moment(packageExpirationDate, 'YYYY-MM-DD') : null
            }),
            moveTime: this.$form.createFormField({
              value: moveTime ? this.moment(moveTime, 'YYYY-MM-DD') : null
            })
          };
        }
      });
    } else {
      this.packageId = null;
      this.form = this.$form.createForm(this, {
        mapPropsToFields: () => {
          return {
            type: this.$form.createFormField({
              value: '01'
            }),
            packageType: this.$form.createFormField({
              value: this.options[0].value
            })
          };
        }
      });
    }
  }
  //提交表单
  async onSubmit() {
    this.form.validateFields(async (err: boolean, values: IForm) => {
      if (!err) {
        const price = this.form.getFieldValue('price');
        const discountPrice = this.form.getFieldValue('discountPrice');
        if (discountPrice && Number(discountPrice) > Number(price))
          return this.$message.error('套餐优惠价格不能大于套餐原价');
        if (values['packageExpirationDate']) {
          const now = new Date(Utils.getFormatTime(new Date(), 'yyyy-MM-DD')).getTime();
          const effectiveDay = new Date(values['packageExpirationDate'].format('YYYY-MM-DD')).getTime();
          if (effectiveDay < now) return this.$message.error('套餐失效日期应不小于当前时间');
        }
        if (values['moveTime']) {
          const now = new Date(Utils.getFormatTime(new Date(), 'yyyy-MM-DD')).getTime();
          const moveTime = new Date(values['moveTime'].format('YYYY-MM-DD')).getTime();
          if (moveTime < now) return this.$message.error('套餐停售日期应不小于当前时间');
        }
        const selectedMerchanIds = [];
        if (this.selectedList.length > 0) {
          for (let i = 0; i < this.selectedList.length; i++) {
            selectedMerchanIds.push({
              pkMerchantId: this.selectedList[i].pkMerchantId,
              orgId: this.selectedList[i].orgId
            });
          }
        }
        this.onAddOrEdit(values, selectedMerchanIds);
      } else {
        console.log('错误', err);
      }
    });
  }
  //新增保存表单
  async onAddOrEdit(values: IForm, list: any[]) {
    const { merchantIds, packageExpirationDate, moveTime, ...rest } = values;
    const json: any = {
      ...rest,
      packageExpirationDate: values['packageExpirationDate']
        ? values['packageExpirationDate'].format('YYYY-MM-DD')
        : '',
      moveTime: values['moveTime'] ? values['moveTime'].format('YYYY-MM-DD') : '',
      merchantIds: list,
      packageId: null
    };
    if (this.packageId) {
      json.packageId = this.packageId;
    }
    if (this.isEdit && this.updateStatus == '01') {
      if (this.confirmLoading) return;
      this.confirmLoading = true;
      try {
        await editCheck(json);
        this.confirmLoading = false;
        this.saveForm(json);
      } catch (e) {
        console.log(e);
        if (e && e.code == '999998') {
          this.refresh = true;
        } else {
          this.refresh = false;
        }
        this.$message.error((e && e.msg) || `${this.isEdit ? '编辑' : '新增'}失败`);
      } finally {
        this.confirmLoading = false;
      }
    } else {
      this.saveForm(json);
    }
  }
  //保存表单
  async saveForm(json) {
    if (this.confirmLoading) return;
    this.confirmLoading = true;
    try {
      const { status, msg } = await addOrEditPackage(json);
      this.successTip(status, msg);
    } catch (e) {
      console.log(e);
      this.$message.error((e && e.msg) || `${this.isEdit ? '编辑' : '新增'}失败`);
    } finally {
      this.confirmLoading = false;
    }
  }
  //成功提示
  successTip(status: string, msg: any) {
    if (status === '9999') {
      this.$message.success(`${this.isEdit ? '编辑' : '新增'}成功`);
      this.form.resetFields();
      this.$emit('create');
      // this.showFlag = false
    } else {
      this.$message.error(msg ? msg : `${this.isEdit ? '编辑' : '新增'}失败`);
    }
  }
  //切换机构
  async changeorgDep(val: any) {
    const type = this.form.getFieldValue('type');
    const { data } = await getMerchantByOrgIdAndType({ orgdepId: val });
    this.couponOptions = data;
    const arr = [];
    this.selectedList = data;
    if (data.length > 0) {
      for (let i = 0; i < data.length; i++) {
        arr.push(data[i].pkMerchantId);
      }
    }
    // this.form.setFieldsValue({
    //   merchantIds: arr,
    // })
  }
  //获取商家列表
  async getMerchantList(val: any) {
    const { data } = await getMerchantByOrgIdAndType({ orgdepId: val });
    this.couponOptions = data;
  }

  //切换商家类型
  async changeMerchantType(val: any) {
    const orgdepId = this.form.getFieldValue('orgId');
    if (val && orgdepId) {
      const { data } = await getMerchantByOrgIdAndType({ orgdepId: orgdepId, type: val });
      this.couponOptions = data;
      const arr = [];
      this.selectedList = data;
      if (data.length > 0) {
        for (let i = 0; i < data.length; i++) {
          arr.push(data[i].pkMerchantId);
        }
      }
      this.form.setFieldsValue({
        merchantIds: arr
      });
    }
  }
  //选择商家时
  changeMerchantIds(val: string | any[]) {
    console.log(val);
    if (val && val.length == 0) {
      this.selectedList = [];
    } else {
      const arr = [];
      for (let i = 0; i < val.length; i++) {
        arr.push({ pkMerchantId: val[i] });
      }
      this.selectedList = _.intersectionBy(this.couponOptions, arr, 'pkMerchantId');
    }
  }
  //失去焦点时计算总价
  blurInput() {
    const price = this.form.getFieldValue('price');
    const discountPrice = this.form.getFieldValue('discountPrice');
    if (price && discountPrice) {
      const priceReg = /^((0{1}\.\d{1,2})|([1-9]\d*\.{1}\d{1,2})|([1-9]+\d*))$/;
      if (priceReg.test(price) && priceReg.test(discountPrice)) {
        if (Number(price) < discountPrice) return this.$message.error('套餐优惠价格不能大于套餐原价');
      }
    }
  }
  //优惠价发生变化时
  changeItemPrice() {
    this.blurInput();
  }
  @Watch('visible')
  visibleChanged(val: boolean) {
    if (val) {
      this.$nextTick(() => {
        this.refresh = false;
        this.init();
      });
    }
  }
  //获取表单名称
  get formTitle() {
    if (this.isCopy) return '复制套餐';
    if (this.isDetail) return '套餐详情';
    if (this.isEdit) return '编辑套餐';
    return '新增套餐';
  }
  filterOption(input: string, option: { componentOptions: { children: { text: string }[] } }) {
    return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  }
  //取消
  closeForm() {
    this.form.resetFields();
    if (this.refresh) {
      this.$emit('create');
    } else {
      this.$emit('cancel');
    }
  }
  mounted() {
    //this.init()
  }
}
